import { Field, ImageField } from '@sitecore-jss/sitecore-jss-react';
import { IconWithTitle } from '../shared/IconWithTitle';
import { OneColumnGrid } from '../shared/OneColumnGrid';
import { TwoColumnGrid } from '../shared/TwoColumnGrid';
import { ComponentProps } from 'lib/component-props';
import UiContainer from '../shared/Container/Container';
import UiBox from '../shared/Box';

type TextDetails = ComponentProps & {
  templateName: string;
  fields: {
    heading: Field<string>;
    content: Field<string>;
    fontColor: Field<string>;
  };
};

type ImageDetails = TextDetails & {
  fields: {
    imageContent?: ImageField;
  };
};

type VideoDetails = TextDetails & {
  fields: {
    videoUrl?: Field<string>;
    isAutoplay?: Field<boolean>;
    isMuted?: Field<boolean>;
  };
};

type ContentDetails = TextDetails | ImageDetails | VideoDetails;

interface IOneAndTwoColumnProps {
  fields: {
    screenRatio: { value: string };
    contentList: ContentDetails[];
    title: Field<string>;
    titleIcon: ImageField;
    iconWithTitleVariant: { value: string };
    iconMobile?: ImageField;
    iconTablet?: ImageField;
    iconDesktop?: ImageField;
  };
}

const OneAndTwoColumn = (props: IOneAndTwoColumnProps): JSX.Element => {
  if (!props?.fields) return <></>;
  const titleIconSrc = props?.fields?.titleIcon?.value?.src;
  const IconWithTitleProps = {
    ...(titleIconSrc && { titleIcon: props?.fields?.titleIcon }),
    title: props.fields.title,
    iconWithTitleVariant: props.fields.iconWithTitleVariant.value,
    iconMobile: props.fields.iconMobile,
    iconTablet: props.fields.iconTablet,
    iconDesktop: props.fields.iconDesktop,
  };

  const isSingleColumn = props?.fields?.contentList.length > 1 ? false : true;

  return (
    <UiContainer id={'about-study'}>
      <UiBox styles={{ maxWidth: '1176px', margin: 'auto' }} className="Study-section">
        <IconWithTitle {...IconWithTitleProps} />
        {isSingleColumn ? (
          <OneColumnGrid {...props.fields?.contentList[0]} isSingleColumn={isSingleColumn} />
        ) : (
          <TwoColumnGrid fields={props.fields} isSingleColumn={isSingleColumn} />
        )}
      </UiBox>
    </UiContainer>
  );
};
export default OneAndTwoColumn;
